export default "__VITE_ASSET__eb45d565__"